// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactModal from "react-modal";
import * as LoadingViewComponent$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as CrmGenericComponentAssetsManager from "../assets/CrmGenericComponentAssetsManager.bs.js";

CrmGenericComponentAssetsManager.importCss(undefined);

function ProgressModal(Props) {
  var isOpen = Props.isOpen;
  var textOpt = Props.text;
  var text = textOpt !== undefined ? textOpt : "Submitting Data";
  return React.createElement("div", undefined, React.createElement(ReactModal, {
                  isOpen: isOpen,
                  onRequestClose: (function (param) {
                      
                    }),
                  overlayClassName: "modal-overlay",
                  className: "c-progress-modal",
                  ariaHideApp: false,
                  shouldCloseOnOverlayClick: false,
                  children: React.createElement("div", undefined, React.createElement(LoadingViewComponent$Catalyst.make, {
                            text: text
                          }))
                }));
}

var make = ProgressModal;

export {
  make ,
  
}
/*  Not a pure module */
